import React from 'react';

import SustainableDevGoals from '../components/SustainableDevGoals';

function SustainableDevGoalsPage() {
  return (
    <div>
      <h2>
 	Sustainable Development Goals
      </h2>

      <SustainableDevGoals />
    </div>
  );
}

export default SustainableDevGoalsPage;



// WEBPACK FOOTER //
// ./src/pages/SustainableDevGoals.js